import {
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {IonSlides} from '@ionic/angular';
import { OrderApiService } from '../../../../core/services/order.api.service';
import { TimeService } from 'src/app/core/services/time.service';

@Component({
  selector: 'app-tip-radio-group',
  templateUrl: './tip-radio-group.component.html',
  styleUrls: ['./tip-radio-group.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TipRadioGroupComponent),
    multi: true
  }]
})
export class TipRadioGroupComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() items;
  @Input() flexCss: string;
  @Input() flexEndCss: string;
  @Input() hasSlide: boolean;
  @Input() itemsInSlide = 5;
  @Input() selectedStart = false;
  @Input() selectedEnd = false;
  @Input() checkedFn;
  @Input() nextFn?: () => Promise<void>;
  @Output()
  public selectItem: EventEmitter<any> = new EventEmitter();
  @Output()
  public selectEnd: EventEmitter<any> = new EventEmitter();
  private _value = false;
  public chunkItems;
  public hoverEnd;
  @ViewChild(IonSlides, {static: false}) slides: IonSlides;
  @ContentChild('item', {static: false}) itemTemplateRef: TemplateRef<any>;
  @ContentChild('start', {static: false}) startTemplateRef: TemplateRef<any>;
  @ContentChild('end', {static: false}) endTemplateRef: TemplateRef<any>;


  get value() {
    return this._value;
  }

  set value(value) {
    this._value = value;
    this.updateChanges();
  }

  public get targetFlexEndCss(): string {
    return this.flexEndCss || this.flexCss;
  }


  constructor(
    private orderApiService: OrderApiService
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges({items}: SimpleChanges): void {
    if (!items) {
      return;
    }
    const {previousValue: previousItems, currentValue: currentItems} = items;
    if (JSON.stringify(previousItems) !== JSON.stringify(currentItems)) {
      this.chunkItems = this.chunkArray(this.items, this.itemsInSlide);
    }
  }

  onChange: (_: any) => void = (_: any) => {
  };

  onTouched: () => void = () => {
  };

  updateChanges() {
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    this._value = value;
    this.updateChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public clickItem(item): void {
    this.value = item;
    this.selectItem.emit(item);
    this.orderApiService.calculateOrders();
  }

  public clickEnd(): void {
    this.selectEnd.emit();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public isChecked(item) {
    return this.checkedFn ? this.checkedFn(item, this.value) : this.value === item;
  }

  private chunkArray(array, chunkSize) {
    const results = [];

    const copyArray = [...array];
    while (copyArray.length) {
      results.push(copyArray.splice(0, chunkSize));
    }
    return results;
  }

  public async updateSlides() {
    await this.slides.update();
  }

  public async onSlideChange() {
    const swiper = await this.slides.getSwiper();
    const currentSlideIndex = swiper.activeIndex;
    const totalSlides = swiper.slides.length;
    if(totalSlides - 2 == currentSlideIndex && this.nextFn){
      await this.nextFn();
    }
  }

  public async next() {
    await this.slides.slideNext();
  }

  public async prev() {
    await this.slides.slidePrev();
  }

}
